/******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ "./src/js/modules/ed-video-component.js":
/*!**********************************************!*\
  !*** ./src/js/modules/ed-video-component.js ***!
  \**********************************************/
/***/ (() => {

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }

function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct; } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var EdVideoThumbnail = /*#__PURE__*/function (_HTMLElement) {
  _inherits(EdVideoThumbnail, _HTMLElement);

  var _super = _createSuper(EdVideoThumbnail);

  function EdVideoThumbnail() {
    var _this;

    _classCallCheck(this, EdVideoThumbnail);

    _this = _super.call(this); // SELECTORS

    _this.popUp = document.querySelector('.video-popup-container');
    _this.popUpVideo = _this.popUp.querySelector('.video-container'); // video inside of popup

    _this.openButton = _this.querySelector('.btn-open');
    _this.closeButton = _this.popUp.querySelector('.btn-close');
    _this.playButton = _this.querySelector('.play-btn'); // ENABLE EXTERNAL POPUP ELEMENT

    if (_this.popUp) {
      document.querySelector('ed-video-popup').setAttribute('enabled', '');
    } // SETUP EVENT LISTENERS


    _this._attachListeners();

    return _this;
  }

  _createClass(EdVideoThumbnail, [{
    key: "videoSrc",
    get: function get() {
      return this.getAttribute('video-src');
    }
  }, {
    key: "autoPlay",
    get: function get() {
      return this.getAttribute('autoplay');
    }
  }, {
    key: "controls",
    get: function get() {
      return this.getAttribute('controls');
    }
  }, {
    key: "_attachListeners",
    value: function _attachListeners() {
      document.addEventListener('keydown', this.closeOnEsc.bind(this));
      this.openButton.addEventListener('click', this.openPopup.bind(this));
      this.playButton.addEventListener('click', this.openPopup.bind(this)); // click outside

      this.popUp.addEventListener('click', this.closePopup.bind(this));
      this.closeButton.addEventListener('click', this.closePopup.bind(this));
    }
  }, {
    key: "openPopup",
    value: function openPopup(e) {
      e.stopPropagation();
      this.createVideo();
      this.popUp.classList.add('open');
      document.documentElement.classList.add('ed-video-popup-open');
    }
  }, {
    key: "closePopup",
    value: function closePopup(e) {
      e.stopPropagation();
      this.popUpVideo.innerHTML = '';
      this.popUp.classList.remove('open');
      document.documentElement.classList.remove('ed-video-popup-open');
    }
  }, {
    key: "closeOnEsc",
    value: function closeOnEsc(e) {
      if (e.key === 'Escape') {
        this.popUpVideo.innerHTML = '';
        document.documentElement.classList.remove('ed-video-popup-open');
        this.popUp.classList.remove('open');
      }
    }
  }, {
    key: "createVideo",
    value: function createVideo() {
      var video = document.createElement('video');
      video.src = this.videoSrc;
      /** settings **/

      video.autoplay = true;
      video.controls = true;

      if (this.autoPlay === 'false') {
        video.autoplay = false;
      }

      if (this.controls === 'false') {
        video.controls = false;
      }

      this.popUpVideo.appendChild(video);
    }
  }]);

  return EdVideoThumbnail;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));

customElements.define('ed-video-thumbnail', EdVideoThumbnail);

var EdVideoPopup = /*#__PURE__*/function (_HTMLElement2) {
  _inherits(EdVideoPopup, _HTMLElement2);

  var _super2 = _createSuper(EdVideoPopup);

  function EdVideoPopup() {
    _classCallCheck(this, EdVideoPopup);

    return _super2.call(this);
  }

  return _createClass(EdVideoPopup);
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));

customElements.define('ed-video-popup', EdVideoPopup);

/***/ }),

/***/ "./src/js/modules/sticky-add-to-cart-bar.js":
/*!**************************************************!*\
  !*** ./src/js/modules/sticky-add-to-cart-bar.js ***!
  \**************************************************/
/***/ (() => {

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }

function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct; } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var StickyAddToCartBar = /*#__PURE__*/function (_HTMLElement) {
  _inherits(StickyAddToCartBar, _HTMLElement);

  var _super = _createSuper(StickyAddToCartBar);

  function StickyAddToCartBar() {
    _classCallCheck(this, StickyAddToCartBar);

    return _super.apply(this, arguments);
  }

  _createClass(StickyAddToCartBar, [{
    key: "active",
    get:
    /** GETTERS AND SETTERS **/
    function get() {
      return this.getAttribute('active');
    }
  }, {
    key: "setActive",
    value: function setActive(value) {
      this.setAttribute('active', value);
    }
  }, {
    key: "vSelectType",
    get: function get() {
      return this.getAttribute('vselect-type');
    }
  }, {
    key: "setProductAvailability",
    value: function setProductAvailability(value) {
      this.setAttribute('product-available', value);
    }
    /** END GETTERS AND SETTERS **/

  }, {
    key: "connectedCallback",
    value: function connectedCallback() {
      /** SETTINGS **/
      this.observerType = this.getAttribute('observer-type');

      this._attachSelectors();

      this._attachListeners();

      this.renderAddToCartButton();
      this.renderPrices();
      this.renderVariantRadios();
    }
  }, {
    key: "_attachSelectors",
    value: function _attachSelectors() {
      this.btnAddToCart = this.querySelector('[data-ed-atc-btn]');
      this.stickyPrice = this.querySelector('[data-ed-product-price]');
      this.stickyComparePrice = this.querySelector('[data-ed-compare-at-price]'); // get default data, as we clone elements from default to the sticky banner

      this.defaultAtcButton = document.querySelector('.product__submit__add'); // TODO: UPDATE

      this.defaultPrice = document.querySelector('.product__price span[data-product-price]'); // TODO: UPDATE

      this.defaultComparePrice = document.querySelector('[data-compare-price]'); // TODO: UPDATE

      if (this.vSelectType === 'radio') {
        this.vSelectContainer = this.querySelector('.select-radio-container');
        this.defaultVariantSelect = document.querySelector('fieldset');
      }
    }
  }, {
    key: "_attachListeners",
    value: function _attachListeners() {
      this.btnAddToCart.addEventListener('click', this.onAddToCart.bind(this));
      this.observeElement(this.defaultAtcButton);
      document.addEventListener('theme:variant:change', this.onVariantChange.bind(this)); // TODO: UPDATE
    }
  }, {
    key: "renderPrices",
    value: function renderPrices() {
      if (this.defaultComparePrice) {
        this.stickyComparePrice.innerText = this.defaultComparePrice.innerText;
        this.stickyPrice.innerText = this.defaultPrice.innerText;
      } else {
        this.stickyComparePrice.innerText = '';
        this.stickyPrice.innerText = this.defaultPrice.innerText;
      }
    }
  }, {
    key: "renderAddToCartButton",
    value: function renderAddToCartButton() {
      this.btnAddToCart.innerHTML = '';
      this.btnAddToCart.appendChild(this.defaultAtcButton.cloneNode(true));
    }
  }, {
    key: "renderVariantRadios",
    value: function renderVariantRadios() {//this.vSelectContainer.appendChild(this.defaultVariantSelect.cloneNode(true));
    }
  }, {
    key: "onVariantChange",
    value: function onVariantChange(e) {
      this.defaultPrice = document.querySelector('.product__price span[data-product-price]');
      this.defaultComparePrice = document.querySelector('[data-compare-price]');
      this.defaultAtcButton = document.querySelector('.product__submit__add');
      this.renderPrices();
      this.renderAddToCartButton();
    }
  }, {
    key: "onAddToCart",
    value: function onAddToCart(e) {
      e.stopPropagation();
      this.defaultAtcButton.click();
    }
    /** INTERSECTION HANDLING **/

  }, {
    key: "observeElement",
    value: function observeElement() {
      var observer;

      if (this.observerType === 'not-visible') {
        observer = new IntersectionObserver(this.handleIntersection.bind(this));
      } else {
        observer = new IntersectionObserver(this.handleIntersection.bind(this), {
          threshold: [0, 0.1, 0.25, 0.5, 0.75, 1]
        });
      }

      observer.observe(this.defaultAtcButton);
    }
  }, {
    key: "handleIntersection",
    value: function handleIntersection(entries) {
      var _this = this;

      // show sticky bar, whenever not visible
      if (this.observerType === 'not-visible') {
        entries.map(function (entry) {
          if (entry.isIntersecting) {
            // hide sticky bar
            _this.setActive('false');
          } else {
            // show sticky bar
            _this.setActive('true');
          }
        });
      } else {
        // show sticky bar, after selector scroll
        var dif = entries[0].boundingClientRect.top;

        if (dif < 0) {
          if (entries[0].isIntersecting) {
            // entered viewport at the top edge, hence scroll direction is up
            this.setActive('true');
          } else {
            // left viewport at the top edge, hence scroll direction is down
            this.setActive('true');
          }
        } else {
          this.setActive('false');
        }
      }
    }
    /** END INTERSECTION HANDLING **/

  }]);

  return StickyAddToCartBar;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));

customElements.define('ed-sticky-add-to-cart-bar', StickyAddToCartBar);

var StickyVariantSelectorDropdown = /*#__PURE__*/function (_HTMLElement2) {
  _inherits(StickyVariantSelectorDropdown, _HTMLElement2);

  var _super2 = _createSuper(StickyVariantSelectorDropdown);

  function StickyVariantSelectorDropdown() {
    var _this2;

    _classCallCheck(this, StickyVariantSelectorDropdown);

    _this2 = _super2.call(this); // selectors

    _this2.selectInput = _this2.querySelector('.select-wrapper select');
    _this2.defaultSelectWrapper = document.querySelector('.selector-wrapper');

    _this2._attachListeners();

    return _this2;
  }

  _createClass(StickyVariantSelectorDropdown, [{
    key: "_attachListeners",
    value: function _attachListeners() {
      this.selectInput.addEventListener('change', this.onVariantSelect.bind(this));
      document.addEventListener('theme:variant:change', this.onVariantChange.bind(this)); // TODO: UPDATE
    } // when something on the default selectors happen

  }, {
    key: "onVariantChange",
    value: function onVariantChange(e) {
      var variant = e.detail.variant;
      this.selectInput.querySelector('option[value="' + variant.title + '"]').selected = true;
      this.selectInput.value = variant.title;
    }
  }, {
    key: "onVariantSelect",
    value: function onVariantSelect() {
      this.defaultSelectWrapper.querySelector('input[value="' + this.selectInput.value + '"]').click();
    }
  }]);

  return StickyVariantSelectorDropdown;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));

customElements.define('ed-vselect-dropdown', StickyVariantSelectorDropdown);

var StickyVariantSelectorRadios = /*#__PURE__*/function (_HTMLElement3) {
  _inherits(StickyVariantSelectorRadios, _HTMLElement3);

  var _super3 = _createSuper(StickyVariantSelectorRadios);

  function StickyVariantSelectorRadios() {
    _classCallCheck(this, StickyVariantSelectorRadios);

    return _super3.apply(this, arguments);
  }

  _createClass(StickyVariantSelectorRadios, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this._attachSelectors();

      this._attachListeners();
    }
  }, {
    key: "_attachSelectors",
    value: function _attachSelectors() {
      this.radioFieldset = this.querySelector('.ed-radio-fieldset');
      this.defaultSelectWrapper = document.querySelector('.radio__fieldset.radio__variants'); // TODO: UPDATE
    }
  }, {
    key: "_attachListeners",
    value: function _attachListeners() {
      this.radioFieldset.addEventListener('change', this.onVariantSelect.bind(this));
      document.addEventListener('theme:variant:change', this.onVariantChange.bind(this)); // TODO: UPDATE
    } // when something on the default selectors happen

  }, {
    key: "onVariantChange",
    value: function onVariantChange(e) {
      var variant = e.detail.variant;
      this.radioFieldset.querySelector('input[value="' + variant.title + '"]').checked = true;
    }
  }, {
    key: "onVariantSelect",
    value: function onVariantSelect() {
      var selectedRadio = this.radioFieldset.querySelector('input:checked');
      this.defaultSelectWrapper.querySelector('input[value="' + selectedRadio.value + '"]').click();
    }
  }]);

  return StickyVariantSelectorRadios;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));

customElements.define('ed-vselect-radios', StickyVariantSelectorRadios);

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry need to be wrapped in an IIFE because it need to be in strict mode.
(() => {
"use strict";
var __webpack_exports__ = {};
/*!**************************!*\
  !*** ./src/js/custom.js ***!
  \**************************/
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _modules_sticky_add_to_cart_bar__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./modules/sticky-add-to-cart-bar */ "./src/js/modules/sticky-add-to-cart-bar.js");
/* harmony import */ var _modules_sticky_add_to_cart_bar__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_modules_sticky_add_to_cart_bar__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _modules_ed_video_component__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./modules/ed-video-component */ "./src/js/modules/ed-video-component.js");
/* harmony import */ var _modules_ed_video_component__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_modules_ed_video_component__WEBPACK_IMPORTED_MODULE_1__);
/*
DO NOT TOUCH THIS FILE OUTSIDE OF /src DIRECTORY
this file gets compiled ./assets/custom.js - make sure to import every module here.
*/

/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/
(function () {// Add custom code below this line
  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();



})();

// This entry need to be wrapped in an IIFE because it need to be in strict mode.
(() => {
"use strict";
/*!******************************!*\
  !*** ./src/scss/custom.scss ***!
  \******************************/
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin

})();

/******/ })()
;